import create from "zustand";

interface iSideNav {
    paddingLeft: string;
    setPaddingLeft: (paddingLeft: string) => void;
}

const useStore = create<iSideNav>((set, get) => ({
    paddingLeft: "240px",

    setPaddingLeft: (padding) => {
        if (padding !== get().paddingLeft) {
            set({
                paddingLeft: padding,
            });
        }
    },
}));

export default useStore;
